module.exports = "<!-- <div>Login Layout</div> -->\n<router-outlet></router-outlet>\n"